import { render, staticRenderFns } from "./BlogEdit.vue?vue&type=template&id=65b36dcd&scoped=true&"
import script from "./BlogEdit.vue?vue&type=script&lang=js&"
export * from "./BlogEdit.vue?vue&type=script&lang=js&"
import style0 from "./BlogEdit.vue?vue&type=style&index=0&id=65b36dcd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b36dcd",
  null
  
)

export default component.exports